import type React from "react";
import { Suspense } from "react";
import { SentryErrorBoundaryForPartialView } from "./sentry-error-boundary";

const SuspenseWithErrorBoundary = (props: {
    readonly name?: string;
    readonly fallback?: React.ReactNode;
    readonly children: React.ReactNode;
}) => {
    return (
        <SentryErrorBoundaryForPartialView>
            <Suspense name={props.name} fallback={props.fallback}>
                {props.children}
            </Suspense>
        </SentryErrorBoundaryForPartialView>
    );
};

export { SuspenseWithErrorBoundary };
